
export type PaymentMethod = 'STRIPE' | 'RAMBURS';

interface PaymentSelectionProps {
  selectedMethod: PaymentMethod;
  onSelect: (method: PaymentMethod) => void;
  isLoading?: boolean;
  onBack?: () => void;
  onContinue: () => void;
}

export function PaymentSelection({
  selectedMethod,
  onSelect,
  isLoading = false,
  onBack,
  onContinue
}: PaymentSelectionProps) {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-white">
        Alege metoda de plată
      </h3>

      <div className="space-y-4">
        <label className="flex items-center p-4 rounded-lg border border-gray-600 bg-gray-800 cursor-pointer hover:border-red-500 transition-colors">
          <input
            type="radio"
            name="paymentMethod"
            value="RAMBURS"
            checked={selectedMethod === 'RAMBURS'}
            onChange={(e) => !isLoading && onSelect(e.target.value as PaymentMethod)}
            className="form-radio text-red-600 focus:ring-red-500"
            disabled={isLoading}
          />
          <div className="ml-4">
            <div className="text-white font-medium">Ramburs</div>
            <div className="text-gray-400 text-sm">Plătești la livrare</div>
          </div>
        </label>

        <label className="flex items-center p-4 rounded-lg border border-gray-600 bg-gray-800 cursor-pointer hover:border-red-500 transition-colors">
          <input
            type="radio"
            name="paymentMethod"
            value="STRIPE"
            checked={selectedMethod === 'STRIPE'}
            onChange={(e) => !isLoading && onSelect(e.target.value as PaymentMethod)}
            className="form-radio text-red-600 focus:ring-red-500"
            disabled={isLoading}
          />
          <div className="ml-4">
            <div className="text-white font-medium">Card</div>
            <div className="text-gray-400 text-sm">Plătești online cu cardul</div>
          </div>
        </label>
      </div>

      <div className="flex justify-between pt-4">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className="bg-gray-600 text-white px-4 py-2 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
            disabled={isLoading}
          >
            Înapoi
          </button>
        )}
        <button
          type="button"
          onClick={isLoading ? undefined : onContinue}
          className={`bg-gradient-to-r from-red-600 to-red-700 text-white px-6 py-2 rounded-md 
            hover:from-red-700 hover:to-red-800 focus:outline-none focus:ring-2 focus:ring-red-500
            disabled:opacity-50 disabled:cursor-not-allowed ml-auto`}
          disabled={isLoading}
        >
          {isLoading ? 'Se procesează...' : 'Continuă'}
        </button>
      </div>
    </div>
  );
}
